module.exports = {"loading":"Loading...","Reset":"Reset","Search":"Search","Confirm Cancel ?":"Confirm Cancel ?","Confirm ?":"Confirm ?","Table display settings":"Table display settings","Check / uncheck to change visibility, drag to change order:":"Check / uncheck to change visibility, drag to change order:","Edit":"Edit","Detail":"Detail","Delete":"Delete","Confirm":"Confirm","Cancel":"Cancel","Select / Unselect All":"Select / Unselect All"}


//////////////////
// WEBPACK FOOTER
// ./packages/lang/test-en.json
// module id = 312
// module chunks = 0